<template>
  <transition name="sf-fade">
    <div v-if="currentRefinements.length">
      <span class="flex justify-between text-sm mb-3">
        <span class="self-center">{{ $t('Filtering by') }}</span>
        <CtClearRefinements @clear="$emit('clear-all')" />
      </span>
      <ul class="flex flex-wrap gap-3 list-none">
        <li
          v-for="refinement in currentRefinements"
          :key="`${refinement.attribute}:${refinement.operator ?? ''}:${refinement.value}`"
        >
          <CurrentRefinementLabel
            :refinement="refinement"
            :create-url="() => ''"
            class="h-7 px-2 rounded bg-EXPONDO-primary-80 text-[0.8rem] text-EXPONDO-white whitespace-nowrap"
            @refine="refinement.remove()"
          />
        </li>
      </ul>
    </div>
  </transition>
</template>

<script setup lang="ts">
import type { ProductListingCurrentRefinement } from '~~/app/composables/useProductListingFilters';

// CT version of SearchFiltersHeader + CustomCurrentRefinements.
defineOptions({ name: 'CtCurrentRefinements' });

withDefaults(defineProps<{
  currentRefinements?: ProductListingCurrentRefinement[];
}>(), {
  currentRefinements: () => [],
});

defineEmits<{
  (event: 'clear-all'): void;
}>();
</script>
